import React from "react"

const Footer = () => (
  <footer className="bg-white border-t border-gray-400 shadow">
    <div className="container max-w-3xl mx-auto flex py-8">
      <div className="w-full mx-auto flex flex-wrap">
        <div className="flex w-full md:w-1/2">
          <div className="px-8">
            <h3 className="font-bold font-bold text-gray-900">About</h3>
            <p className="py-4 text-gray-600 text-sm">
              This prediction engine is a machine-learning experiment by{" "}
              <a
                href="http://www.substantial.com/"
                className="inline-block text-gray-600 underline hover:text-gray-900 hover:text-underline"
              >
                Substantial
              </a>
              .
            </p>
            <p className="py-4 text-gray-600 text-sm">
              It was trained on historical sales data from February 2020 and can
              predict with reasonable accuracy whether a game will succeed or
              fail in the steam marketplace solely from its top-3 tags.
            </p>
            <p className="py-4 text-gray-600 text-sm">
              In other words, just as there are garbage genres like{" "}
              <em>Indie</em> <em>Pixel-Art</em> <em>Runner</em> there are
              high-demand genres like <em>Open World</em> <em>Sci-Fi</em>{" "}
              <em>Action-RPG</em>.
            </p>
          </div>
        </div>

        <div className="flex w-full md:w-1/2">
          <div className="px-8">
            <h3 className="font-bold font-bold text-gray-900">Social</h3>
            <ul className="list-reset items-center text-sm pt-3">
              <li>
                <a
                  className="inline-block text-gray-600 underline hover:text-gray-900 hover:text-underline py-1"
                  href="https://substantial.com"
                >
                  Substantial
                </a>
              </li>
              <li>
                <a
                  className="inline-block text-gray-600 underline hover:text-gray-900 hover:text-underline py-1"
                  href="https://twitter.com/mikelovesrobots"
                >
                  Mike (Lead Dev)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
